import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

export interface ReOrderDialogData {
  currentOrder: number;
  titleSuffix: string;
}

@Component({
  selector: 'app-re-order-dialog',
  templateUrl: './re-order-dialog.component.html',
  styleUrl: './re-order-dialog.component.scss',
  standalone: true,
  imports: [
    ModalBaseComponent,
    NgTemplateOutlet,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf
  ]
})
export class ReOrderDialogComponent implements OnInit {
  form: UntypedFormGroup;
  isLoading = false;
  dialogTitle: string;
  canSend = false;

  constructor(
    public dialogRef: MatDialogRef<ReOrderDialogComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ReOrderDialogData
  ) {
    this.dialogTitle = 'Réordonner le ' + this.data.titleSuffix;
  }

  // convenience getter for easy access to form fields
  get form_order() {
    return this.form.get('order') as FormControl<number>;
  }
  ngOnInit() {
    this.form = this.fb.group({
      order: [null, [Validators.min(1), Validators.required]]
    });
    this.form_order.patchValue(this.data.currentOrder);
  }

  onSubmit() {
    if (this.form.valid) {
      this.dialogRef.close(this.form_order.value);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
